function readEnv(key: string): string | undefined {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const v = (import.meta as any)?.env?.[key]
    return typeof v === 'string' && v.length > 0 ? v : undefined
  } catch {
    return undefined
  }
}

function resolveApiBaseUrl(): string {
  const raw = readEnv('VITE_API_BASE_URL')
  if (raw) return raw
  return ''
}

export const API_BASE_URL = resolveApiBaseUrl()

function resolveBrowserHostname(): string {
  try {
    const h = globalThis.location?.hostname
    if (typeof h === 'string' && h.length > 0 && h !== '0.0.0.0') return h
  } catch {
    // ignore
  }
  return 'localhost'
}

function resolveWsProtocol(): 'ws:' | 'wss:' {
  try {
    const p = globalThis.location?.protocol
    return p === 'https:' ? 'wss:' : 'ws:'
  } catch {
    return 'ws:'
  }
}

function normalizeWsBaseUrl(raw: string): string {
  try {
    const u = new URL(raw)
    if (u.hostname === '0.0.0.0') u.hostname = resolveBrowserHostname()
    return u.toString()
  } catch {
    return raw
  }
}

function defaultWsUrl(): string {
  try {
    const proto = resolveWsProtocol()
    const host = globalThis.location?.host
    if (host) return `${proto}//${host}/ws`
  } catch {
    // ignore
  }
  return ''
}

export const WS_BASE_URL = normalizeWsBaseUrl(
  readEnv('VITE_API_WS_URL') ?? defaultWsUrl()
)

/** Append JWT for WS handshake — browsers cannot set Authorization on WebSocket. */
export function authenticatedWsUrl(baseUrl: string, accessToken: string | null): string {
  if (!accessToken) return baseUrl
  try {
    const u = new URL(baseUrl)
    u.searchParams.set('token', accessToken)
    return u.toString()
  } catch {
    const sep = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${sep}token=${encodeURIComponent(accessToken)}`
  }
}

export function wsUrlForLog(url: string): string {
  try {
    const u = new URL(url)
    return `${u.origin}${u.pathname}`
  } catch {
    return url.split('?')[0] ?? url
  }
}

export function apiUrl(pathname: string): string {
  const base = API_BASE_URL.replace(/\/+$/, '')
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`
  return `${base}${path}`
}
